import { render, staticRenderFns } from "./ReportDetailPagePurchase.vue?vue&type=template&id=5f7ba532&scoped=true&"
import script from "./ReportDetailPagePurchase.vue?vue&type=script&lang=js&"
export * from "./ReportDetailPagePurchase.vue?vue&type=script&lang=js&"
import style0 from "./ReportDetailPagePurchase.vue?vue&type=style&index=0&id=5f7ba532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7ba532",
  null
  
)

component.options.__file = "ReportDetailPagePurchase.vue"
export default component.exports